import * as React from 'react';
import { useTheme } from '@/themes';
import classnames from 'classnames';
import { JohnLewisProgressBar } from '@/themes/jl-money/custom/JohnLewisProgressBar';
import { ProductTemplate as ZopaProductTemplate, ProductTemplateV2, Heading, Text } from '@zopauk/react-components';

interface CommonProductTemplateProps {
  title: React.ReactNode | string;
  contentWidth?: number;
  currentStep?: number;
  subtitle?: string;
}

const steps: string[] = ['Find', 'Check', 'Pre-approval', 'Your details', 'Apply', 'Confirm'];

export function ProductTemplate({
  currentStep = 0,
  subtitle,
  children,
  title,
}: React.PropsWithChildren<CommonProductTemplateProps>) {
  const { partnerName, theme } = useTheme();

  // TODO: Migrate to ProductTemplateV2
  if (partnerName === 'zopa' && typeof title === 'string') {
    return (
      <>
        <ZopaProductTemplate subtitle={subtitle} title={title}>
          <ZopaProductTemplate.Card>{children}</ZopaProductTemplate.Card>
        </ZopaProductTemplate>
      </>
    );
  }

  if (partnerName === 'zopa' && typeof title !== 'string') {
    throw new Error('Zopa theme does not support ReactNode title');
  }

  if (partnerName === 'jl-money') {
    return (
      <>
        <ProductTemplateV2
          header={{
            title: (
              <Heading
                className={classnames(theme?.productTemplateV2?.titleClassName, 'm:mb-7')}
                align="center"
                as="h1"
              >
                {title}
              </Heading>
            ),
            progressBar: <JohnLewisProgressBar currentStep={currentStep} className="mb-7 m:mb-9" steps={steps} />,
          }}
        >
          {subtitle ? (
            <Text className={classnames(theme?.productTemplateV2?.subtitleClassName, 'pt-8', 'pb-7')}>{subtitle}</Text>
          ) : null}
          <div className={classnames({ 'pt-8': !subtitle })}>{children}</div>
        </ProductTemplateV2>
      </>
    );
  }

  throw new Error(`Unsupported theme ${partnerName}`);
}
